import { Image, tokens } from 'ComponentLibrary'
import DataPlaceholderImage from 'ComponentLibrary/src/assets/images/data-placeholder.svg'
import { PlaceholderCard } from 'ClientPortal/src/pages/MarketData/Placeholder/NoDataPlaceholder'
import { Typography } from 'ComponentLibrary/src/piazza/text'
import { Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const MarketDataNoData = () => {
    const { t } = useTranslation('pages', { keyPrefix: 'marketData.noData' })

    return (
        <PlaceholderCard>
            <Image height={100} objectFit="contain" src={DataPlaceholderImage} alt={t('imageAlt')} />
            <Stack direction="column" gap={tokens.SizingSpacing050}>
                <Typography variant="textS" color={tokens.ColorTextSubtle}>
                    {t('lineOne')}
                </Typography>
                <Typography variant="textS" color={tokens.ColorTextSubtle}>
                    {t('lineTwo')}
                </Typography>
            </Stack>
        </PlaceholderCard>
    )
}
